import { useEffect, useState,useRef } from "react";
import { Grid, Segment, Header, Button, Form, Checkbox, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

const Advertising = ({ show, data, onClickDelete, onClickCancel, onClickSubmit, onFileChange }) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState();
  const inputFile = useRef(null);

  useEffect(() => {
    if (data) {
      setFormData({
        ...data,
        startDate: formatDateForInput(data.startDate),
        endDate: formatDateForInput(data.endDate),
      });
    }
  }, [data]);

  if (!show || !data) return null;

  const formatDateForInput = (isoDate) => {
    if (!isoDate) return '';
    return isoDate.split('T')[0];
  };
  
  const handleOnChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleOnAddFile = () => {
    inputFile.current.click();
  };

  const handleOnFileChange = async (e) => {
    onFileChange({id: data.id, e})
  };

  return (
    <section>
      <Grid columns="equal" stackable>
        <Grid.Column width={10}>
          <Segment basic color="blue" padded="very">
            <Header as="h3">{t(`headline-information`)}</Header>
            <Form>
              <Form.Input
                id="title"
                onChange={handleOnChange}
                value={formData?.title || ''}
                label={t(`input-label-title`)}
                placeholder={t(`input-placeholder-title`)}
              />
              <Form.Input
                id="subtitle"
                onChange={handleOnChange}
                value={formData?.subtitle || ''}
                label={t(`input-label-subtitle`)}
                placeholder={t(`input-placeholder-subtitle`)}
              />
              <Form.TextArea
                rows={12}
                onChange={handleOnChange}
                id="content"
                value={formData?.content || ''}
                label={t(`input-label-content`)}
                placeholder={t(`input-placeholder-content`)}
              />
            </Form>
          </Segment>
        </Grid.Column>
        <Grid.Column>
          <Segment basic color="blue" padded="very">
            <Header as="h3">{t(`headline-visibility`)}</Header>
            <Form.Field>
              <Checkbox
                toggle
                checked={!!formData?.isActive}
                onChange={(e, { checked }) =>
                  setFormData(prev => ({ ...prev, isActive: checked ? 1 : 0 }))
                }
              />
            </Form.Field>
            <Form>
              <Form.Input
                id="startDate"
                type="Date"
                onChange={handleOnChange}
                value={formData?.startDate || ''}
                label={t(`input-label-startDate`)}
                placeholder={t(`input-placeholder-startDate`)}
              />
              <Form.Input
                id="endDate"
                type="Date"
                onChange={handleOnChange}
                value={formData?.endDate || ''}
                label={t(`input-label-endDate`)}
                placeholder={t(`input-placeholder-endDate`)}
              />
            </Form>
          </Segment>
          <Segment basic color="blue" padded="very">
            <Header as="h3">{t(`headline-details`)}</Header>
            <Form>
              <Form.Input
                icon='linkify'
                iconPosition='left'
                id="imageUrl"
                onChange={handleOnChange}
                value={formData?.imageUrl || ''}
                label={t(`input-label-imageUrl`)}
                placeholder={t(`input-placeholder-imageUrl`)}
                actionPosition="right"
                action={
                  <>
                    <input type='file' id='file' ref={inputFile} style={{display: 'none'}} onChange={handleOnFileChange} accept=".jpg,.jpeg,.webp,.png"/>
                    <Button primary animated='vertical' onClick={handleOnAddFile} floated='right'>
                      <Button.Content hidden>{t(`button-upload`)}</Button.Content>
                      <Button.Content visible>
                        <Icon name='upload' />
                      </Button.Content>
                    </Button>
                  </>
                }
              />
            </Form>
          </Segment>
        </Grid.Column>
      </Grid>
      <Grid columns="equal" stackable>
        <Grid.Column>
          <Button key={`button-advertising-delete`} floated='left' size='medium' onClick={() => onClickDelete({id: data.id})} >
            <Icon name="trash" />
            {t('button-delete')}
          </Button>
          <Button floated='right' primary size='medium' onClick={() =>
              onClickSubmit({ id: data.id, data: formData })
            }>
            <Icon name="check" />
            {t(`button-save`)}
          </Button>
          <Button floated='right' size='medium' onClick={()=>onClickCancel()}>
            <Icon name="check" />
            {t(`button-cancel`)}
          </Button>
        </Grid.Column>
      </Grid>
    </section>
  );
};

export default Advertising;
